<template>
  <div class="row">
    <div class="col-md-12">
      <b-button
        v-if="false"
        class="addRowButton"
        :pressed.sync="report"
        style="float: right; margin-top: 1em;">
        {{ $t('message.lblReport') }}
      </b-button>
    </div>
    <div class="col-md-12">
      <transition
        name="fade"
        mode="out-in">

        <download-page v-if="!report"/>

        <report-page v-if="report"/>

      </transition>
    </div>
  </div>
</template>

<script>
import downloadPage from '@/wizardElements/download/download.vue';
import reportPage from '@/wizardElements/download/report.vue';

export default {
  components: {
    downloadPage,
    reportPage,
  },
  data() {
    return {
      report: false,
    };
  },
};
</script>

<style>
.dist-top {
  margin-top: 2em;
}
</style>
